// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary-orange: #0E1A2B;
  --color-primary-green: #d1ac72;
  --color-text-dark: #1e2530;
  --color-text-body: #4c5258;
  --color-white: #fff;
  --color-danger: #fd3550;
  --color-info-blue: #037de2;
  --color-link-blue: #0d6efd;
  --color-teal: #0a7674;
  --color-teal-hover: #0d9d9a;
  --color-border-light: #ddd;
  --color-bg-page: #f8f9fb;
  --color-bg-panel: #faf7f2;
  --color-bg-hover: #f8f9fa;
  --color-icon-muted: #6c757d;
  --color-dark-slate: #313a46;

  /* merged: nearly identical to text-dark (#1e2530 vs #1a2332), now shares one source */
  --color-sidebar-bg: #0E1A2B;

  /* merged: nearly identical to dark-slate (#313a46 vs #2d3748), now shares one source */
  --color-sidebar-border: var(--color-dark-slate);

  --color-menu-text: #cbd5e1;
  --color-menu-label: #b0afaf;
  --color-icon-slate: var(--color-white);
  --color-menu-hover-bg: var(--color-sidebar-border);
--color-menu-hover-text: var(--color-white);
--color-menu-active-bg: var(--color-text-dark);
--color-menu-active-text: var(--color-primary-green);
  --color-white-a50: #ffffff50;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: var(--color-white);
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

body {
  background: var(--color-bg-page);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  color: var(--color-text-body);
  letter-spacing: .5px;
  overflow-x: hidden;
}

html {
  overflow: hidden;
}

.wrapper {
  display: flex;
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
}

.edit {
  margin-right: 5px;
}

.main {
  width: 100%;
  height: calc(100% - 70px);
  margin-top: 45px;
  margin-bottom: 20px;
  margin-left: 290px;
  padding: 1.5rem 1.5rem 0.7rem 1.5rem;
  overflow: auto;
}

.wrapper.toggled .main {
  margin-left: 70px;
}

@media screen and (max-width: 768px) {
  .main{
    margin-left:0px !important;
  }
}

.wrapper.toggled .topbar {
  left: 70px;
}
@media screen and (max-width: 768px) {
  .topbar{
    left:0px !important;
  }
}

.default-btn-color {
  background-color: var(--color-primary-green) !important;
  border-color: var(--color-primary-green) !important;
  color: var(--color-text-dark) !important;
  font-weight: 600;
  font-size: 0.8rem;
  
}

/* .btn-primary {
  background-color: var(--color-primary-green) !important;
	border-color: var(--color-primary-green) !important;
} */

.error-text {
  color: var(--color-danger);
}

.modal-title {
  font-weight: bold;
  font-size: 1.25em;
}

.form-control {
  font-size: 1em;
}

.title-heading {
  font-size: 20px;
  margin-top: 20px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
  padding-right: 5px;
}

.datepicker input[readonly] {
  background-color: var(--color-border-light);
}

.add-btn-icon {
  color: var(--color-primary-green);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.edit-btn-icon {
  color: var(--color-info-blue);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

.delete-btn-icon {
  color: var(--color-danger);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}

dt {
  margin-bottom: .5rem;
  font-family: Arial, Helvetica, sans-serif;
  color: black;
}



.top-tab {
  border: none;
  background-color: rgb(238, 234, 234);
  margin: 1px 1px 0px 1px;
  position: relative;
  z-index: 8;
  padding: 5px 20px;
  border-top: 1px solid rgba(0, 0, 0, .125);
  border-right: 1px solid rgba(0, 0, 0, .125);
  border-left: 1px solid rgba(0, 0, 0, .125);
  border-radius: 0.25rem .25rem 0 0;

  transform: translate(0, 1px);
}

.top-tab.selected {
  background-color: var(--color-white);
}

.trackerInfo {
  padding: 10px;
  margin: 20px 0px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.trackerInfo h6 {
  font-weight: bold;
  margin: 5px 0px 20px 0px;
}

.formPage .row .col-md-6 {
  margin-top: 1.5rem
}

.role-permissions-row .col label {
  margin-top: 6px;
  font-size: 1.1rem;
  white-space: nowrap;
}

.role-permissions-row {
  padding: 7px 0 7px 0;
  /* border-bottom: 1px solid #00000050; */
}

.detailsPageHeader {
  position: sticky;
  top: 0;
  background: var(--color-bg-page);
  z-index: 9;
  padding-top: 15px;
  transform: translate(0px, -1.5rem);
  margin-bottom: -1.5rem;
}

@media (max-width: 575.98px) {
  .default-btn-color {
    padding: 10px;
  }
}

dl.row {
  margin-bottom: .3rem;
}

.redirectLink {
  color: var(--color-text-dark);
  text-decoration: none;
}
.redirectLink:hover{
  color:var(--color-primary-orange);
}

.custom-table-view{
  height: 400px;
  overflow: auto;
}
.custom-table{
  padding: 5px;
  border-collapse: collapse;
  width: 100%;
}
.table>:not(:first-child){
  border-top: none !important;
}
.custom-table td, .custom-table th{
  border: 1px solid var(--color-border-light) !important;
  padding: 8px;
}
.custom-table tr:nth-child(even){background-color: #f2f2f2 !important;}

.custom-table tr:hover {background-color: var(--color-border-light) !important;}

.custom-table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color:var(--color-primary-green) !important;
  color: var(--color-white);
}

.custom-table span{
  text-transform:capitalize;
}

.cutImage{
  display: block;
  margin: 0px auto;
  width: 100%;
  /* width: 250px; */
}

.sampleFile{
  position: absolute;
  right: 50px;
}

#download-content .viewHeader {
  font-size: 2.5rem !important;
}

.custom-orange-table td,
.custom-orange-table th,
.custom-orange-table tr,
.custom-orange-table thead,
.custom-orange-table tbody {
  border-color:var(--color-primary-orange) !important;
}

.no-border {
  border-color: transparent !important;
}

.custom-btn {
  float: right;
  font-size: 0.9rem;
  margin-bottom: 10px;;
}

.custom-header {
  background-color: #D1D1E8; /* Change to your desired color */
  color: #000; /* Text color */
  font-weight: bold;
  text-align: center;
  font-size: 0.85rem;
  border: 1px solid var(--color-border-light); /* Optional: Add border */
}

.dash-odd-row {
  background-color: #eff5f8 !important; /* Light blue for odd rows */
  color: #333; /* Text color for odd rows */
}

.dash-even-row {
  background-color: var(--color-white); /* White for even rows */
  color: #333; /* Text color for even rows */
}

.statTile-txt
{
  color:#000 !important;
  font-size: 1rem;
  font-weight: bold;
}

.msg-btn, .msg-btn:hover {
  background-color: transparent !important;
  border-color: transparent !important;
  color: var(--color-primary-orange);
  font-size: 2rem;
}

.dropdown-custom .dropdown-item:hover {
  background-color: #444444	 !important; /* Highlight color on hover */
  color: rgb(214, 212, 212) !important; /* Optional: make text readable */
}
.notification-preview * {
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

.notification-preview p {
  margin: 0 0 10px;
}

.notification-preview img {
  display: block;
  /* vertical-align: middle; */
  max-width: 100%;
  height: auto;
}
/* Make the actual Quill container resizable */
.editor-container .ql-container {
  min-height: 180px;
  max-height: 600px;
  resize: vertical;   /* native expand/collapse handle */
  overflow: auto;     /* scrollbar only when needed */
  border: 1px solid var(--color-border-light);
  background: var(--color-white);
}

/* Let editor grow inside */
.editor-container .ql-editor {
  min-height: 150px;
  height: auto;
  overflow-y: auto;
}

/* Keep images responsive inside */
.editor-container .ql-editor img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0;
}

/* Keep heading flush to the left */
.notification-heading {
  text-align: center;
  color:#000;  
  margin-bottom: 6px;
  font-weight: 600;
}

/* Indent content slightly to the right */
.notification-preview {
  padding-left: 20px; 
}

/* Fine-tune inner content */
.notification-preview p,
.notification-preview div {
  margin: 2px 0 !important; /* reduce vertical gaps */
}

.notification-preview img,
.notification-preview video {
  margin-top: 4px;
}

.preview-btn-color {
  background-color: var(--color-primary-orange) !important;
  border-color: var(--color-primary-orange) !important;
  color: var(--color-white) !important;
}

/* date alignment issue fix */
.datepicker .react-datepicker-wrapper {
  width: 100%;
}

/* Ticketing sys */
.ticketing-link {
  background: var(--color-teal);
  color: var(--color-white);
  padding: 3px 12px;
  border-radius: 5px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(10, 118, 116, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  /* position: relative; */
}

.ticketing-link:hover {
  background: var(--color-teal-hover);
  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.5), 
              0 0 20px rgba(10, 118, 116, 0.3);
  transform: translateY(-2px);
}

.question-tabs{
  border: 1px solid var(--color-primary-orange);
  border-radius: 4px;
  color: #000;
  transition: all 0.1s ease;
  box-shadow: none !important;
}

.question-tabs-selected{
  background-color: var(--color-primary-orange);
  color: var(--color-white);
  box-shadow: none !important;
}

.question-tabs-selected:hover {
  color: var(--color-white);
}

.question-tabs:hover {
  border-color: var(--color-primary-orange);
  background-color: #fff7ed;
  color: #000;
}
.category-pill {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background-color: #f1f3f5;
  color: #212529;
  font-size: 0.8125rem;
  font-weight: 500;
  text-decoration: none;
  border: 1px solid #dee2e6;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.category-pill:hover {
  background-color: #e7f1ff;
  border-color: var(--color-link-blue);
  color: var(--color-link-blue);
}
.detailsPageHeader .breadcrumb-wrapper {
  flex: 1 1;
  min-width: 0;
}

.detailsPageHeader .header-actions {
  white-space: nowrap;
}
@media (max-width: 768px) {
  .detailsPageHeader {
    transform: none;
    margin-bottom: 0;
  }
}
.details-header-actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

@media (max-width: 768px) {
  .details-header-actions {
    justify-content: flex-start;
  }

  .details-header-actions > * {
    flex: 0 0 auto;
  }
}
@media (max-width: 768px) {
  .card-body select.float-end {
    height: 32px;
    padding: 4px 8px;
    margin-top: 2px;
  }
}
.date-divider-line {
  flex-grow: 1;
  border: none;
  border-top: 1px solid var(--color-primary-orange);
  margin: 0 10px;
}
.search-input-outline {
  border: 1px solid var(--color-primary-orange);
}
.metrics-filter-select {
  background-color: #fff9f5;
  color: #333;
  border-color: var(--color-primary-orange);
  appearance: none;
  padding-right: 2rem;
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem auto;
  height: calc(2.25rem + 2px);
  line-height: 1.5;
}
.btn-preview-orange {
	background-color: var(--color-primary-orange);
	border-color: var(--color-primary-orange);
	color: var(--color-white);
}
.badge-required {
  background-color: rgba(220, 53, 69, 0.15);
  color: var(--color-primary-orange);
  border-radius: 12px;
  font-weight: 600;
  padding: 5px 10px;
  font-size: 13px;
}
/* ---------- Login (matches SSO) ---------- */
.login-page {
  --lg-navy: #142335;
  --lg-gold: #d3a66c;
  --lg-gold-light: #f0c58c;
  --lg-ink: #18283d;
  --lg-muted: #61718a;
  --lg-line: #d6dfed;

  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, "Segoe UI", Arial, sans-serif;
  letter-spacing: normal;
  background: radial-gradient(ellipse at 53% 55%, #20364d 0%, var(--lg-navy) 68%);
  overflow-y: auto;
}

.login-shell {
  width: min(1200px, 70vw);
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: clamp(40px, 6vw, 100px);
  padding: clamp(16px, 3vh, 48px) clamp(24px, 5vw, 80px);
  margin: auto;
}

/* ---- Left hero ---- */
.login-hero {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.login-hero-logo {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 20vh;
  height: auto;
  margin: 0 auto;
}
.login-hero-rule {
  width: 20%;
  height: 5px;
  border-radius: 6px;
  background: var(--lg-gold-light);
  margin: 0 15px 3vh 15px;
}

.login-portals {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}
.login-portal {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 1.6vh 22px;
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 12px;
  background: rgba(255, 255, 255, .04);
  color: #fff;
  text-decoration: none;
  transition: border-color .2s, background .2s;
}
.login-portal:hover {
  border-color: rgba(211, 166, 108, .5);
  background: rgba(255, 255, 255, .06);
  color: #fff;
}
.login-portal.active {
  border-color: var(--lg-gold);
  background: rgba(211, 166, 108, .08);
}

.login-portal-icon { flex: 0 0 auto; display: flex; }
.login-portal-icon svg,
.login-portal-arrow {
  width: 26px;
  height: 26px;
  fill: none;
  stroke: var(--lg-gold);
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.login-portal-arrow { width: 18px; height: 18px; }
.login-portal-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.login-portal-text strong { font-size: 17px; font-weight: 600; }
.login-portal-text small { font-size: 14px; color: #b9c4d2; }

.login-partners {
  margin-top: 4vh;
  width: 100%;
}
.login-partners-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  color: #f4f5f7;
  letter-spacing: .24em;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
  margin-bottom: 2vh;
}
.login-partners-label::before,
.login-partners-label::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #cbd4df;
  opacity: .85;
}
.login-partners-strip {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  justify-items: center;
  gap: 12px;
  width: 100%;
  min-height: 0;
  padding: 2vh 24px;
  background: #fff;
  border-radius: 24px;
}
.login-partners-strip img {
  display: block;
  width: 100%;
  max-width: 120px;
  height: clamp(36px, 5vh, 55px);
  object-fit: contain;
}

/* ---- Right card ---- */
.login-card {
  background: #fff;
  color: var(--lg-ink);
  border-radius: 17px;
  padding: clamp(20px, 4vh, 48px);
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 18px 55px rgba(0, 0, 0, .09);
}
.login-brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 2vh;
}
.login-logo {
  width: 9vh;
  height: 9vh;
  object-fit: contain;
  margin: 0 auto 1.2vh;
}
.login-brand h1 {
  font-size: clamp(26px, 4vh, 38px);
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -.035em;
  color: var(--lg-ink);
  margin: 0;
}
.login-brand p {
  font-size: 16px;
  color: var(--lg-muted);
  margin: 8px 0 0;
}
.login-portal-pill {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 1vh 18px;
    margin-bottom: 2vh;
    background: #f5f7fb;
    border: 1px solid var(--lg-line);
    border-radius: 9px;
}
.login-portal-pill .login-portal-icon svg {
  width: 24px;
  height: 24px;
  stroke: #1c3453;
}
.login-portal-pill .login-portal-text strong { color: var(--lg-ink); font-size: 16px; }
.login-portal-pill .login-portal-text small { color: var(--lg-muted); font-size: 14px; }
 .login-field {
    position: relative;
    margin-bottom: 26px;
}
.login-field label {
    display: block;
    color: #566780;
    font-size: 17px;
    font-weight: 600;
    margin: 0 0 5px;
}

.login-input-wrap { position: relative; }
.login-input-icon {
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  fill: none;
  stroke: #1c3453;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
  pointer-events: none;
}

.login-input {
  display: block;
  width: 100%;
  height: clamp(44px, 6vh, 60px);
  padding: 0 54px 0 60px;
  font: inherit;
  font-size: 16px;
  color: var(--lg-ink);
  background: #fff;
  border: 1px solid var(--lg-line);
  border-radius: 9px;
  outline: none;
}
.login-input::placeholder { color: #70809a; }
.login-input:focus {
  border-color: var(--lg-gold);
  box-shadow: 0 0 0 3px rgba(211, 166, 108, .17);
}
.login-input.is-invalid { border-color: #e5484d; }
.login-error { 
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 3px;
  font-size: 13px;
  color: #e5484d; 
}

.login-forgot {
  display: block;
  width: fit-content;          /* new: link is only as wide as the text */
  margin: -0.5vh 0 3vh auto;   /* was -0.5vh 0 3vh; auto pushes it right */
  color: #b77c37;
  font-size: 17px;
  text-decoration: none;
}
.login-forgot:hover { color: #b77c37; text-decoration: underline; }

/* beats .default-btn-color's !important */
.login-btn.default-btn-color {
  width: 100% !important;
  height: clamp(46px, 6.5vh, 64px);
  border: 0;
  border-radius: 9px;
  background-color: var(--lg-gold) !important;
  border-color: var(--lg-gold) !important;
  color: var(--lg-ink) !important;
  font-size: 20px;
  font-weight: 700;
  transition: background .2s;
}
.login-btn.default-btn-color:hover { background-color: #e0b57d !important; }

/* ---- Tablet ---- */
@media (max-width: 1000px) {
  .login-shell { width: 100%; gap: 32px; padding: 24px 36px; }
  .login-card { padding: 28px; min-height: 0; }
  .login-partners-strip { gap: 8px; padding: 2vh 14px; }
  .login-partners-strip img { max-width: 105px; height: 44px; }
}

/* ---- Mobile: fit everything in one screen ---- */
@media (max-width: 768px) {
  .login-page {
    height: auto;
    min-height: 100dvh;
    align-items: stretch;
    overflow-y: auto;
  }

  .login-shell {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    max-width: 570px;
    height: auto;
    min-height: auto;
    margin: 0 auto;
    padding: 2vh 16px 4vh;
    gap: 2vh;
    display: flex;
    flex-direction: column;
  }

  /* Hero */
  .login-hero {
    display: contents;
  }

  .login-hero-logo { width: 70%; max-height: 6vh; margin: 0 auto 0px; order: 1; }
  .login-hero-rule { height: 3px; margin: 0 0 1.5vh; display: none;}

  .login-portals { gap: 2vh; order: 2; display:none; }
  .login-portal { padding: 1vh 14px; gap: 12px; }
  .login-portal-icon svg { width: 20px; height: 20px; }
  .login-portal-text strong { font-size: 14px; }
  .login-portal-text small { display: none; }   /* hide descriptions */

  .login-partners {
    order: 4;
    margin-top: 1vh;
  }
  .login-partners-label { font-size: 10px; gap: 8px; margin-bottom: 1vh; }
  .login-partners-strip {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
    padding: 1vh 10px;
    border-radius: 14px;
  }
  .login-partners-strip img { height: 3.5vh; max-width: 60px; }

  /* Card */
  .login-card {
    order: 3;
    padding: 10% 20px;
    justify-content: flex-start;
    min-height: 0;
    overflow-y: visible;
    margin-top:0;
  }
  .login-logo { width: 5vh; height: 5vh; margin-bottom: 0.8vh;  }
  .login-brand { margin-bottom: 1.5vh; }
  .login-brand h1 { font-size: 3.2vh; }
  .login-brand p { font-size: 13px; margin-top: 4px; }

  .login-portal-pill { display: none; }   /* already shown as active portal above */

  .login-field { margin-bottom: 2.5vh; }
  .login-field label { font-size: 14px; margin-bottom: 3px; }
  .login-input { height: 5.5vh; min-height: 40px; font-size: 16px; }
  .login-forgot { font-size: 14px; margin: -1vh 0 1.5vh auto; }
  .login-btn.default-btn-color { height: 5.5vh; min-height: 42px; font-size: 16px; }
}
.login-shell--single {
  grid-template-columns: 1fr;
  max-width: 520px;
}

.login-success {
  background: #f0f9f4;
  border: 1px solid #b7e4c7;
  color: #1e6b3f;
  border-radius: 9px;
  padding: 14px 18px;
  font-size: 15px;
  text-align: center;
}

.login-back {
  display: block;
  text-align: center;
  margin-top: 2.5vh;
  color: #b77c37;
  font-size: 16px;
  text-decoration: none;
}
.login-back:hover { color: #b77c37; text-decoration: underline; }
.login-shell--single .login-brand h1 {
  font-size: clamp(22px, 3vh, 28px);
}

.login-shell--single .login-brand p {
  font-size: 14px;
}

.login-page--light {
  background: #fff;
}

.login-page--light .login-card {
  border: 1px solid var(--lg-line);
}
.login-alert {
  background: #fdecec;
  border: 1px solid #f5c2c7;
  color: #b42318;
  border-radius: 9px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 2vh;
}

.login-hint {
  font-size: 13px;
  color: var(--lg-muted);
  margin: -0.5vh 0 2.5vh;
}
.login-hint ul {
  margin: 4px 0 0;
  padding-left: 18px;
  columns: 2;
}

.login-input[readonly] {
  background: #f5f7fb;
  color: var(--lg-muted);
}
.login-page--top {
  align-items: flex-start;
}

.login-page--top .login-shell {
  margin: -1vh auto auto;
}

.login-shell--single .login-field {
  margin-bottom: clamp(35px, 3.8vh, 38px);   /* was 24–30px */
}
.login-shell--single .login-btn.default-btn-color {
  height: 36px;
  font-size: 14px;
  width: 30% !important;
  display: block;
  margin: 0 auto;             /* centers it */
}
@media (max-width: 768px) {
  .login-page--reset {
    align-items: center;
  }
  .login-page--reset .login-shell {
    margin: auto;
  }
  .login-page--reset .login-logo {
  display: block;
}
}
.login-subtitle {
  display: none;
}
@media (max-width: 768px) {
  .login-subtitle {
    display: block;
  }
}
.copy-btn {
  padding: 0;
  color: var(--color-primary-green);
  text-decoration: none;
  vertical-align: baseline;
}
.copy-btn:hover,
.copy-btn:focus {
  color: var(--color-primary-green);
  opacity: 0.8;
}

.wvgo-link-btn {
  padding: 0;
  color: var(--color-teal);
  text-decoration: none;
  font-weight: normal;
}
.wvgo-link-btn:hover {
  color: var(--color-teal-hover);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;;EAE3B,sFAAsF;EACtF,2BAA2B;;EAE3B,uFAAuF;EACvF,+CAA+C;;EAE/C,0BAA0B;EAC1B,2BAA2B;EAC3B,sCAAsC;EACtC,kDAAkD;AACpD,2CAA2C;AAC3C,8CAA8C;AAC9C,oDAAoD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;AACZ;AACA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;EACnD,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;;;GAGG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,YAAY;AACd;;;;AAIA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,yCAAyC;EACzC,2CAA2C;EAC3C,0CAA0C;EAC1C,iCAAiC;;EAEjC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gCAAgC;EAChC,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,YAAY;AACd;AACA,iCAAiC,oCAAoC,CAAC;;AAEtE,wBAAwB,sDAAsD,CAAC;;AAE/E;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,WAAW,EAAE,eAAe;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C,EAAE,yBAAyB;AACxE;;AAEA;EACE,oCAAoC,EAAE,4BAA4B;EAClE,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;EAC9D,WAAW,EAAE,6BAA6B;AAC5C;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,qCAAqC,EAAE,6BAA6B;EACpE,oCAAoC,EAAE,iCAAiC;AACzE;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;AACA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB,IAAI,kCAAkC;EACtD,cAAc,MAAM,+BAA+B;EACnD,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,wBAAwB,EAAE,yBAAyB;AACrD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC;8CAC4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;EACjD,cAAc;AAChB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;CACC,6CAA6C;CAC7C,yCAAyC;CACzC,yBAAyB;AAC1B;AACA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,sBAAsB;EACtB,+EAA+E;EAC/E,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;EACtD,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA,qBAAqB,cAAc,EAAE,aAAa,EAAE;AACpD;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,4BAA4B,eAAe,EAAE,gBAAgB,EAAE;AAC/D,2BAA2B,eAAe,EAAE,cAAc,EAAE;;AAE5D;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA,+CAA+C,oBAAoB,EAAE,eAAe,EAAE;AACtF,8CAA8C,sBAAsB,EAAE,eAAe,EAAE;CACtF;IACG,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,oBAAoB,kBAAkB,EAAE;AACxC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;AACA,4BAA4B,cAAc,EAAE;AAC5C;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA,0BAA0B,qBAAqB,EAAE;AACjD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB,WAAW,0CAA0C;EACvE,yBAAyB,IAAI,2CAA2C;EACxE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,cAAc,EAAE,0BAA0B,EAAE;;AAElE,0CAA0C;AAC1C;EACE,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,qCAAqC,oCAAoC,EAAE;;AAE3E,qBAAqB;AACrB;EACE,eAAe,WAAW,EAAE,SAAS,EAAE,kBAAkB,EAAE;EAC3D,cAAc,aAAa,EAAE,aAAa,EAAE;EAC5C,wBAAwB,QAAQ,EAAE,iBAAiB,EAAE;EACrD,4BAA4B,gBAAgB,EAAE,YAAY,EAAE;AAC9D;;AAEA,mDAAmD;AACnD;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,QAAQ;IACR,aAAa;IACb,sBAAsB;EACxB;;EAEA,SAAS;EACT;IACE,iBAAiB;EACnB;;EAEA,mBAAmB,UAAU,EAAE,eAAe,EAAE,kBAAkB,EAAE,QAAQ,EAAE;EAC9E,mBAAmB,WAAW,EAAE,iBAAiB,EAAE,aAAa,CAAC;;EAEjE,iBAAiB,QAAQ,EAAE,QAAQ,EAAE,YAAY,EAAE;EACnD,gBAAgB,iBAAiB,EAAE,SAAS,EAAE;EAC9C,yBAAyB,WAAW,EAAE,YAAY,EAAE;EACpD,4BAA4B,eAAe,EAAE;EAC7C,2BAA2B,aAAa,EAAE,IAAI,sBAAsB;;EAEpE;IACE,QAAQ;IACR,eAAe;EACjB;EACA,wBAAwB,eAAe,EAAE,QAAQ,EAAE,kBAAkB,EAAE;EACvE;IACE,gDAAgD;IAChD,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;EACrB;EACA,4BAA4B,aAAa,EAAE,eAAe,EAAE;;EAE5D,SAAS;EACT;IACE,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;EACA,cAAc,UAAU,EAAE,WAAW,EAAE,oBAAoB,GAAG;EAC9D,eAAe,oBAAoB,EAAE;EACrC,kBAAkB,gBAAgB,EAAE;EACpC,iBAAiB,eAAe,EAAE,eAAe,EAAE;;EAEnD,qBAAqB,aAAa,EAAE,IAAI,yCAAyC;;EAEjF,eAAe,oBAAoB,EAAE;EACrC,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;EAC1D,eAAe,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;EACjE,gBAAgB,eAAe,EAAE,yBAAyB,EAAE;EAC5D,+BAA+B,aAAa,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACnF;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA,oBAAoB,cAAc,EAAE,0BAA0B,EAAE;AAChE;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC,IAAI,gBAAgB;AAC7D;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,cAAc,cAAc,eAAe;AAC7C;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;EACA,cAAc;AAChB;AACA;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;EAEE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[":root {\n  --color-primary-orange: #0E1A2B;\n  --color-primary-green: #d1ac72;\n  --color-text-dark: #1e2530;\n  --color-text-body: #4c5258;\n  --color-white: #fff;\n  --color-danger: #fd3550;\n  --color-info-blue: #037de2;\n  --color-link-blue: #0d6efd;\n  --color-teal: #0a7674;\n  --color-teal-hover: #0d9d9a;\n  --color-border-light: #ddd;\n  --color-bg-page: #f8f9fb;\n  --color-bg-panel: #faf7f2;\n  --color-bg-hover: #f8f9fa;\n  --color-icon-muted: #6c757d;\n  --color-dark-slate: #313a46;\n\n  /* merged: nearly identical to text-dark (#1e2530 vs #1a2332), now shares one source */\n  --color-sidebar-bg: #0E1A2B;\n\n  /* merged: nearly identical to dark-slate (#313a46 vs #2d3748), now shares one source */\n  --color-sidebar-border: var(--color-dark-slate);\n\n  --color-menu-text: #cbd5e1;\n  --color-menu-label: #b0afaf;\n  --color-icon-slate: var(--color-white);\n  --color-menu-hover-bg: var(--color-sidebar-border);\n--color-menu-hover-text: var(--color-white);\n--color-menu-active-bg: var(--color-text-dark);\n--color-menu-active-text: var(--color-primary-green);\n  --color-white-a50: #ffffff50;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: var(--color-white);\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody {\n  background: var(--color-bg-page);\n  font-family: Roboto, sans-serif;\n  font-size: 14px;\n  color: var(--color-text-body);\n  letter-spacing: .5px;\n  overflow-x: hidden;\n}\n\nhtml {\n  overflow: hidden;\n}\n\n.wrapper {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.edit {\n  margin-right: 5px;\n}\n\n.main {\n  width: 100%;\n  height: calc(100% - 70px);\n  margin-top: 45px;\n  margin-bottom: 20px;\n  margin-left: 290px;\n  padding: 1.5rem 1.5rem 0.7rem 1.5rem;\n  overflow: auto;\n}\n\n.wrapper.toggled .main {\n  margin-left: 70px;\n}\n\n@media screen and (max-width: 768px) {\n  .main{\n    margin-left:0px !important;\n  }\n}\n\n.wrapper.toggled .topbar {\n  left: 70px;\n}\n@media screen and (max-width: 768px) {\n  .topbar{\n    left:0px !important;\n  }\n}\n\n.default-btn-color {\n  background-color: var(--color-primary-green) !important;\n  border-color: var(--color-primary-green) !important;\n  color: var(--color-text-dark) !important;\n  font-weight: 600;\n  font-size: 0.8rem;\n  \n}\n\n/* .btn-primary {\n  background-color: var(--color-primary-green) !important;\n\tborder-color: var(--color-primary-green) !important;\n} */\n\n.error-text {\n  color: var(--color-danger);\n}\n\n.modal-title {\n  font-weight: bold;\n  font-size: 1.25em;\n}\n\n.form-control {\n  font-size: 1em;\n}\n\n.title-heading {\n  font-size: 20px;\n  margin-top: 20px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #ccc;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.datepicker input[readonly] {\n  background-color: var(--color-border-light);\n}\n\n.add-btn-icon {\n  color: var(--color-primary-green);\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.edit-btn-icon {\n  color: var(--color-info-blue);\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.delete-btn-icon {\n  color: var(--color-danger);\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n}\n\ndt {\n  margin-bottom: .5rem;\n  font-family: Arial, Helvetica, sans-serif;\n  color: black;\n}\n\n\n\n.top-tab {\n  border: none;\n  background-color: rgb(238, 234, 234);\n  margin: 1px 1px 0px 1px;\n  position: relative;\n  z-index: 8;\n  padding: 5px 20px;\n  border-top: 1px solid rgba(0, 0, 0, .125);\n  border-right: 1px solid rgba(0, 0, 0, .125);\n  border-left: 1px solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem .25rem 0 0;\n\n  transform: translate(0, 1px);\n}\n\n.top-tab.selected {\n  background-color: var(--color-white);\n}\n\n.trackerInfo {\n  padding: 10px;\n  margin: 20px 0px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n}\n\n.trackerInfo h6 {\n  font-weight: bold;\n  margin: 5px 0px 20px 0px;\n}\n\n.formPage .row .col-md-6 {\n  margin-top: 1.5rem\n}\n\n.role-permissions-row .col label {\n  margin-top: 6px;\n  font-size: 1.1rem;\n  white-space: nowrap;\n}\n\n.role-permissions-row {\n  padding: 7px 0 7px 0;\n  /* border-bottom: 1px solid #00000050; */\n}\n\n.detailsPageHeader {\n  position: sticky;\n  top: 0;\n  background: var(--color-bg-page);\n  z-index: 9;\n  padding-top: 15px;\n  transform: translate(0px, -1.5rem);\n  margin-bottom: -1.5rem;\n}\n\n@media (max-width: 575.98px) {\n  .default-btn-color {\n    padding: 10px;\n  }\n}\n\ndl.row {\n  margin-bottom: .3rem;\n}\n\n.redirectLink {\n  color: var(--color-text-dark);\n  text-decoration: none;\n}\n.redirectLink:hover{\n  color:var(--color-primary-orange);\n}\n\n.custom-table-view{\n  height: 400px;\n  overflow: auto;\n}\n.custom-table{\n  padding: 5px;\n  border-collapse: collapse;\n  width: 100%;\n}\n.table>:not(:first-child){\n  border-top: none !important;\n}\n.custom-table td, .custom-table th{\n  border: 1px solid var(--color-border-light) !important;\n  padding: 8px;\n}\n.custom-table tr:nth-child(even){background-color: #f2f2f2 !important;}\n\n.custom-table tr:hover {background-color: var(--color-border-light) !important;}\n\n.custom-table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color:var(--color-primary-green) !important;\n  color: var(--color-white);\n}\n\n.custom-table span{\n  text-transform:capitalize;\n}\n\n.cutImage{\n  display: block;\n  margin: 0px auto;\n  width: 100%;\n  /* width: 250px; */\n}\n\n.sampleFile{\n  position: absolute;\n  right: 50px;\n}\n\n#download-content .viewHeader {\n  font-size: 2.5rem !important;\n}\n\n.custom-orange-table td,\n.custom-orange-table th,\n.custom-orange-table tr,\n.custom-orange-table thead,\n.custom-orange-table tbody {\n  border-color:var(--color-primary-orange) !important;\n}\n\n.no-border {\n  border-color: transparent !important;\n}\n\n.custom-btn {\n  float: right;\n  font-size: 0.9rem;\n  margin-bottom: 10px;;\n}\n\n.custom-header {\n  background-color: #D1D1E8; /* Change to your desired color */\n  color: #000; /* Text color */\n  font-weight: bold;\n  text-align: center;\n  font-size: 0.85rem;\n  border: 1px solid var(--color-border-light); /* Optional: Add border */\n}\n\n.dash-odd-row {\n  background-color: #eff5f8 !important; /* Light blue for odd rows */\n  color: #333; /* Text color for odd rows */\n}\n\n.dash-even-row {\n  background-color: var(--color-white); /* White for even rows */\n  color: #333; /* Text color for even rows */\n}\n\n.statTile-txt\n{\n  color:#000 !important;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.msg-btn, .msg-btn:hover {\n  background-color: transparent !important;\n  border-color: transparent !important;\n  color: var(--color-primary-orange);\n  font-size: 2rem;\n}\n\n.dropdown-custom .dropdown-item:hover {\n  background-color: #444444\t !important; /* Highlight color on hover */\n  color: rgb(214, 212, 212) !important; /* Optional: make text readable */\n}\n.notification-preview * {\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n}\n\n.notification-preview p {\n  margin: 0 0 10px;\n}\n\n.notification-preview img {\n  display: block;\n  /* vertical-align: middle; */\n  max-width: 100%;\n  height: auto;\n}\n/* Make the actual Quill container resizable */\n.editor-container .ql-container {\n  min-height: 180px;\n  max-height: 600px;\n  resize: vertical;   /* native expand/collapse handle */\n  overflow: auto;     /* scrollbar only when needed */\n  border: 1px solid var(--color-border-light);\n  background: var(--color-white);\n}\n\n/* Let editor grow inside */\n.editor-container .ql-editor {\n  min-height: 150px;\n  height: auto;\n  overflow-y: auto;\n}\n\n/* Keep images responsive inside */\n.editor-container .ql-editor img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 0;\n}\n\n/* Keep heading flush to the left */\n.notification-heading {\n  text-align: center;\n  color:#000;  \n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n/* Indent content slightly to the right */\n.notification-preview {\n  padding-left: 20px; \n}\n\n/* Fine-tune inner content */\n.notification-preview p,\n.notification-preview div {\n  margin: 2px 0 !important; /* reduce vertical gaps */\n}\n\n.notification-preview img,\n.notification-preview video {\n  margin-top: 4px;\n}\n\n.preview-btn-color {\n  background-color: var(--color-primary-orange) !important;\n  border-color: var(--color-primary-orange) !important;\n  color: var(--color-white) !important;\n}\n\n/* date alignment issue fix */\n.datepicker .react-datepicker-wrapper {\n  width: 100%;\n}\n\n/* Ticketing sys */\n.ticketing-link {\n  background: var(--color-teal);\n  color: var(--color-white);\n  padding: 3px 12px;\n  border-radius: 5px;\n  border: none;\n  font-weight: 600;\n  font-size: 16px;\n  box-shadow: 0 2px 8px rgba(10, 118, 116, 0.3);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  /* position: relative; */\n}\n\n.ticketing-link:hover {\n  background: var(--color-teal-hover);\n  box-shadow: 0 4px 20px rgba(10, 118, 116, 0.5), \n              0 0 20px rgba(10, 118, 116, 0.3);\n  transform: translateY(-2px);\n}\n\n.question-tabs{\n  border: 1px solid var(--color-primary-orange);\n  border-radius: 4px;\n  color: #000;\n  transition: all 0.1s ease;\n  box-shadow: none !important;\n}\n\n.question-tabs-selected{\n  background-color: var(--color-primary-orange);\n  color: var(--color-white);\n  box-shadow: none !important;\n}\n\n.question-tabs-selected:hover {\n  color: var(--color-white);\n}\n\n.question-tabs:hover {\n  border-color: var(--color-primary-orange);\n  background-color: #fff7ed;\n  color: #000;\n}\n.category-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background-color: #f1f3f5;\n  color: #212529;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  text-decoration: none;\n  border: 1px solid #dee2e6;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.category-pill:hover {\n  background-color: #e7f1ff;\n  border-color: var(--color-link-blue);\n  color: var(--color-link-blue);\n}\n.detailsPageHeader .breadcrumb-wrapper {\n  flex: 1;\n  min-width: 0;\n}\n\n.detailsPageHeader .header-actions {\n  white-space: nowrap;\n}\n@media (max-width: 768px) {\n  .detailsPageHeader {\n    transform: none;\n    margin-bottom: 0;\n  }\n}\n.details-header-actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n@media (max-width: 768px) {\n  .details-header-actions {\n    justify-content: flex-start;\n  }\n\n  .details-header-actions > * {\n    flex: 0 0 auto;\n  }\n}\n@media (max-width: 768px) {\n  .card-body select.float-end {\n    height: 32px;\n    padding: 4px 8px;\n    margin-top: 2px;\n  }\n}\n.date-divider-line {\n  flex-grow: 1;\n  border: none;\n  border-top: 1px solid var(--color-primary-orange);\n  margin: 0 10px;\n}\n.search-input-outline {\n  border: 1px solid var(--color-primary-orange);\n}\n.metrics-filter-select {\n  background-color: #fff9f5;\n  color: #333;\n  border-color: var(--color-primary-orange);\n  appearance: none;\n  padding-right: 2rem;\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1rem auto;\n  height: calc(2.25rem + 2px);\n  line-height: 1.5;\n}\n.btn-preview-orange {\n\tbackground-color: var(--color-primary-orange);\n\tborder-color: var(--color-primary-orange);\n\tcolor: var(--color-white);\n}\n.badge-required {\n  background-color: rgba(220, 53, 69, 0.15);\n  color: var(--color-primary-orange);\n  border-radius: 12px;\n  font-weight: 600;\n  padding: 5px 10px;\n  font-size: 13px;\n}\n/* ---------- Login (matches SSO) ---------- */\n.login-page {\n  --lg-navy: #142335;\n  --lg-gold: #d3a66c;\n  --lg-gold-light: #f0c58c;\n  --lg-ink: #18283d;\n  --lg-muted: #61718a;\n  --lg-line: #d6dfed;\n\n  height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Inter, \"Segoe UI\", Arial, sans-serif;\n  letter-spacing: normal;\n  background: radial-gradient(ellipse at 53% 55%, #20364d 0%, var(--lg-navy) 68%);\n  overflow-y: auto;\n}\n\n.login-shell {\n  width: min(1200px, 70vw);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: clamp(40px, 6vw, 100px);\n  padding: clamp(16px, 3vh, 48px) clamp(24px, 5vw, 80px);\n  margin: auto;\n}\n\n/* ---- Left hero ---- */\n.login-hero {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.login-hero-logo {\n  display: block;\n  width: auto;\n  max-width: 100%;\n  max-height: 20vh;\n  height: auto;\n  margin: 0 auto;\n}\n.login-hero-rule {\n  width: 20%;\n  height: 5px;\n  border-radius: 6px;\n  background: var(--lg-gold-light);\n  margin: 0 15px 3vh 15px;\n}\n\n.login-portals {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  width: 100%;\n}\n.login-portal {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  padding: 1.6vh 22px;\n  border: 1px solid rgba(255, 255, 255, .12);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, .04);\n  color: #fff;\n  text-decoration: none;\n  transition: border-color .2s, background .2s;\n}\n.login-portal:hover {\n  border-color: rgba(211, 166, 108, .5);\n  background: rgba(255, 255, 255, .06);\n  color: #fff;\n}\n.login-portal.active {\n  border-color: var(--lg-gold);\n  background: rgba(211, 166, 108, .08);\n}\n\n.login-portal-icon { flex: 0 0 auto; display: flex; }\n.login-portal-icon svg,\n.login-portal-arrow {\n  width: 26px;\n  height: 26px;\n  fill: none;\n  stroke: var(--lg-gold);\n  stroke-width: 1.6;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.login-portal-arrow { width: 18px; height: 18px; }\n.login-portal-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.login-portal-text strong { font-size: 17px; font-weight: 600; }\n.login-portal-text small { font-size: 14px; color: #b9c4d2; }\n\n.login-partners {\n  margin-top: 4vh;\n  width: 100%;\n}\n.login-partners-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  color: #f4f5f7;\n  letter-spacing: .24em;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin-bottom: 2vh;\n}\n.login-partners-label::before,\n.login-partners-label::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #cbd4df;\n  opacity: .85;\n}\n.login-partners-strip {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  align-items: center;\n  justify-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 0;\n  padding: 2vh 24px;\n  background: #fff;\n  border-radius: 24px;\n}\n.login-partners-strip img {\n  display: block;\n  width: 100%;\n  max-width: 120px;\n  height: clamp(36px, 5vh, 55px);\n  object-fit: contain;\n}\n\n/* ---- Right card ---- */\n.login-card {\n  background: #fff;\n  color: var(--lg-ink);\n  border-radius: 17px;\n  padding: clamp(20px, 4vh, 48px);\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: 0 18px 55px rgba(0, 0, 0, .09);\n}\n.login-brand {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 2vh;\n}\n.login-logo {\n  width: 9vh;\n  height: 9vh;\n  object-fit: contain;\n  margin: 0 auto 1.2vh;\n}\n.login-brand h1 {\n  font-size: clamp(26px, 4vh, 38px);\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -.035em;\n  color: var(--lg-ink);\n  margin: 0;\n}\n.login-brand p {\n  font-size: 16px;\n  color: var(--lg-muted);\n  margin: 8px 0 0;\n}\n.login-portal-pill {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    padding: 1vh 18px;\n    margin-bottom: 2vh;\n    background: #f5f7fb;\n    border: 1px solid var(--lg-line);\n    border-radius: 9px;\n}\n.login-portal-pill .login-portal-icon svg {\n  width: 24px;\n  height: 24px;\n  stroke: #1c3453;\n}\n.login-portal-pill .login-portal-text strong { color: var(--lg-ink); font-size: 16px; }\n.login-portal-pill .login-portal-text small { color: var(--lg-muted); font-size: 14px; }\n .login-field {\n    position: relative;\n    margin-bottom: 26px;\n}\n.login-field label {\n    display: block;\n    color: #566780;\n    font-size: 17px;\n    font-weight: 600;\n    margin: 0 0 5px;\n}\n\n.login-input-wrap { position: relative; }\n.login-input-icon {\n  position: absolute;\n  left: 18px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  fill: none;\n  stroke: #1c3453;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  pointer-events: none;\n}\n\n.login-input {\n  display: block;\n  width: 100%;\n  height: clamp(44px, 6vh, 60px);\n  padding: 0 54px 0 60px;\n  font: inherit;\n  font-size: 16px;\n  color: var(--lg-ink);\n  background: #fff;\n  border: 1px solid var(--lg-line);\n  border-radius: 9px;\n  outline: none;\n}\n.login-input::placeholder { color: #70809a; }\n.login-input:focus {\n  border-color: var(--lg-gold);\n  box-shadow: 0 0 0 3px rgba(211, 166, 108, .17);\n}\n.login-input.is-invalid { border-color: #e5484d; }\n.login-error { \n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 3px;\n  font-size: 13px;\n  color: #e5484d; \n}\n\n.login-forgot {\n  display: block;\n  width: fit-content;          /* new: link is only as wide as the text */\n  margin: -0.5vh 0 3vh auto;   /* was -0.5vh 0 3vh; auto pushes it right */\n  color: #b77c37;\n  font-size: 17px;\n  text-decoration: none;\n}\n.login-forgot:hover { color: #b77c37; text-decoration: underline; }\n\n/* beats .default-btn-color's !important */\n.login-btn.default-btn-color {\n  width: 100% !important;\n  height: clamp(46px, 6.5vh, 64px);\n  border: 0;\n  border-radius: 9px;\n  background-color: var(--lg-gold) !important;\n  border-color: var(--lg-gold) !important;\n  color: var(--lg-ink) !important;\n  font-size: 20px;\n  font-weight: 700;\n  transition: background .2s;\n}\n.login-btn.default-btn-color:hover { background-color: #e0b57d !important; }\n\n/* ---- Tablet ---- */\n@media (max-width: 1000px) {\n  .login-shell { width: 100%; gap: 32px; padding: 24px 36px; }\n  .login-card { padding: 28px; min-height: 0; }\n  .login-partners-strip { gap: 8px; padding: 2vh 14px; }\n  .login-partners-strip img { max-width: 105px; height: 44px; }\n}\n\n/* ---- Mobile: fit everything in one screen ---- */\n@media (max-width: 768px) {\n  .login-page {\n    height: auto;\n    min-height: 100dvh;\n    align-items: stretch;\n    overflow-y: auto;\n  }\n\n  .login-shell {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n    max-width: 570px;\n    height: auto;\n    min-height: auto;\n    margin: 0 auto;\n    padding: 2vh 16px 4vh;\n    gap: 2vh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Hero */\n  .login-hero {\n    display: contents;\n  }\n\n  .login-hero-logo { width: 70%; max-height: 6vh; margin: 0 auto 0px; order: 1; }\n  .login-hero-rule { height: 3px; margin: 0 0 1.5vh; display: none;}\n\n  .login-portals { gap: 2vh; order: 2; display:none; }\n  .login-portal { padding: 1vh 14px; gap: 12px; }\n  .login-portal-icon svg { width: 20px; height: 20px; }\n  .login-portal-text strong { font-size: 14px; }\n  .login-portal-text small { display: none; }   /* hide descriptions */\n\n  .login-partners {\n    order: 4;\n    margin-top: 1vh;\n  }\n  .login-partners-label { font-size: 10px; gap: 8px; margin-bottom: 1vh; }\n  .login-partners-strip {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 6px;\n    padding: 1vh 10px;\n    border-radius: 14px;\n  }\n  .login-partners-strip img { height: 3.5vh; max-width: 60px; }\n\n  /* Card */\n  .login-card {\n    order: 3;\n    padding: 10% 20px;\n    justify-content: flex-start;\n    min-height: 0;\n    overflow-y: visible;\n    margin-top:0;\n  }\n  .login-logo { width: 5vh; height: 5vh; margin-bottom: 0.8vh;  }\n  .login-brand { margin-bottom: 1.5vh; }\n  .login-brand h1 { font-size: 3.2vh; }\n  .login-brand p { font-size: 13px; margin-top: 4px; }\n\n  .login-portal-pill { display: none; }   /* already shown as active portal above */\n\n  .login-field { margin-bottom: 2.5vh; }\n  .login-field label { font-size: 14px; margin-bottom: 3px; }\n  .login-input { height: 5.5vh; min-height: 40px; font-size: 16px; }\n  .login-forgot { font-size: 14px; margin: -1vh 0 1.5vh auto; }\n  .login-btn.default-btn-color { height: 5.5vh; min-height: 42px; font-size: 16px; }\n}\n.login-shell--single {\n  grid-template-columns: 1fr;\n  max-width: 520px;\n}\n\n.login-success {\n  background: #f0f9f4;\n  border: 1px solid #b7e4c7;\n  color: #1e6b3f;\n  border-radius: 9px;\n  padding: 14px 18px;\n  font-size: 15px;\n  text-align: center;\n}\n\n.login-back {\n  display: block;\n  text-align: center;\n  margin-top: 2.5vh;\n  color: #b77c37;\n  font-size: 16px;\n  text-decoration: none;\n}\n.login-back:hover { color: #b77c37; text-decoration: underline; }\n.login-shell--single .login-brand h1 {\n  font-size: clamp(22px, 3vh, 28px);\n}\n\n.login-shell--single .login-brand p {\n  font-size: 14px;\n}\n\n.login-page--light {\n  background: #fff;\n}\n\n.login-page--light .login-card {\n  border: 1px solid var(--lg-line);\n}\n.login-alert {\n  background: #fdecec;\n  border: 1px solid #f5c2c7;\n  color: #b42318;\n  border-radius: 9px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 2vh;\n}\n\n.login-hint {\n  font-size: 13px;\n  color: var(--lg-muted);\n  margin: -0.5vh 0 2.5vh;\n}\n.login-hint ul {\n  margin: 4px 0 0;\n  padding-left: 18px;\n  columns: 2;\n}\n\n.login-input[readonly] {\n  background: #f5f7fb;\n  color: var(--lg-muted);\n}\n.login-page--top {\n  align-items: flex-start;\n}\n\n.login-page--top .login-shell {\n  margin: -1vh auto auto;\n}\n\n.login-shell--single .login-field {\n  margin-bottom: clamp(35px, 3.8vh, 38px);   /* was 24–30px */\n}\n.login-shell--single .login-btn.default-btn-color {\n  height: 36px;\n  font-size: 14px;\n  width: 30% !important;\n  display: block;\n  margin: 0 auto;             /* centers it */\n}\n@media (max-width: 768px) {\n  .login-page--reset {\n    align-items: center;\n  }\n  .login-page--reset .login-shell {\n    margin: auto;\n  }\n  .login-page--reset .login-logo {\n  display: block;\n}\n}\n.login-subtitle {\n  display: none;\n}\n@media (max-width: 768px) {\n  .login-subtitle {\n    display: block;\n  }\n}\n.copy-btn {\n  padding: 0;\n  color: var(--color-primary-green);\n  text-decoration: none;\n  vertical-align: baseline;\n}\n.copy-btn:hover,\n.copy-btn:focus {\n  color: var(--color-primary-green);\n  opacity: 0.8;\n}\n\n.wvgo-link-btn {\n  padding: 0;\n  color: var(--color-teal);\n  text-decoration: none;\n  font-weight: normal;\n}\n.wvgo-link-btn:hover {\n  color: var(--color-teal-hover);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
